// BSS-27701: prod API calls go to the leadgen door (CloudFront + WAF in front of the
// private API Gateway), not to the site's own distribution.
const API = 'https://edge-l.beaconstreetservices.com';

export const environment = {
  APP_ENV: 'PROD',
  production: true,
  env: 'prod',
  SITE_DETAILS_API: `${API}/site/api/v2/details`,
  ASSET_DETAILS_API : 'https://marketingassets.marketwise.com',
  OFFER_EXPIRY_PAGE: 'https://marketingassets.marketwise.com/test/templates/OfferEndedPage/offer_ended_page.html',
  CREATE_ELETTER_API: `${API}/public/leads/api/v1/eletter`,
  CREATE_HOTLIST_API: `${API}/public/leads/api/v1/hotlist`,
  CREATE_COI_API: `${API}/public/leads/api/v1/customer-settings/coi`,
  DOUBLE_OPTIN_SEND_EMAIL_API: `${API}/public/leads/api/v1/customer-settings/doi`,
  EVENTSTREAM_API: `${API}/public/snowflake/api/v1/generic`,
  DDG_LOGGER_CLIENT: 'pub2a1eacb4678c8ac666513170783471aa',
  SNOW_PLOW_COLLECTOR_URL: 'com-marketwise-prod1.collector.snplow.net',
  AWS_WAF_CAPTCHA_API: `${API}/site/api/v2/waf/captcha`,
  // BSS-27701: door build asks HpmPage for the <host>#cf row (CloudFront captcha key)
  AWS_WAF_CAPTCHA_DOMAIN_SUFFIX: '#cf',
  AWS_WAF_CHALLENGE_SCRIPT_URL: 'https://4071fd28d0c2.edge.sdk.awswaf.com/4071fd28d0c2/8ff42827cc40/challenge.js'
};
